import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { getIsFetchingActiveUser, getActiveUser } from 'Store/reducers';
import { postLoginWithRetries } from 'Store/users/actions';
import { ROUTES } from 'Settings/route-strings';
import { getIsPostingLogin } from 'Store/users/reducers';

import Loading from 'Components/Loading';
import SectionHeader from 'Components/SectionHeader';
import ContentFrame from 'Components/ContentFrame';
import Button from 'Components/Button';
import PaymentError from 'Components/PaymentError/PaymentError';

class UserReactivationLoading extends React.PureComponent {
  componentDidMount() {
    const { authInfo } = this.props;
    if (authInfo) {
      this.props.postLoginWithRetries({ ...authInfo });
    }
  }

  render() {
    const { isPostingLogin, isFetchingActiveUser, activeUser } = this.props;

    if (isPostingLogin || isFetchingActiveUser) {
      return (
        <main className="Page__content">
          <Loading description="Payment received! Logging you in..." />
        </main>
      );
    }

    if (activeUser) {
      return (
        <Redirect
          to={{
            pathname: ROUTES.SETTINGS_SUBSCRIPTION_CONFIRMATION,
            state: { justSubscribed: true, needsAuthToken: true },
          }}
        />
      );
    }

    return <PaymentError />;
  }
}

const mapStateToProps = state => {
  return {
    isFetchingActiveUser: getIsFetchingActiveUser(state),
    isPostingLogin: getIsPostingLogin(state),
    activeUser: getActiveUser(state),
  };
};

export default connect(mapStateToProps, {
  postLoginWithRetries,
})(UserReactivationLoading);
